import { pipe } from 'ramda';

import {
  buildCmsUrl,
  CMSArrayBase,
  CMSGroupParams,
  CMSImageBase,
  CMSScheduler,
  getResponseCMS,
  LIMIT_500,
} from './base';
import { request } from '@/api/base';
import { getResponseCamelization } from '@/helpers/api';
import { isCMSV3 } from '@/helpers/conf';

export enum ButtonType {
  Deposit = 'deposit',
  Link = 'link',
  None = 'none',
  ShowMore = 'show_more',
  Explore = 'explore',
  ReadMore = 'read_more',
  JoinNow = 'join_now',
  t = 'play_now',
}

export interface Slide extends CMSArrayBase, CMSGroupParams, CMSScheduler {
  title: string;
  description: string;
  buttonType: ButtonType;
  buttonLink: string;
  backgroundDesktop: CMSImageBase;
  backgroundMobile: CMSImageBase;
  charactersDesktop: CMSImageBase;
  charactersMobile: CMSImageBase;
  showAllUsers: boolean;
  order: number;
}

export const sliderCMSV3 = (lang: string) =>
  request<Slide[]>({
    url: buildCmsUrl({ path: 'slides-v-3-s', lang, limit: LIMIT_500 }),
  });

export const sliderCMSV4 = (lang: string) =>
  request<Slide[]>({
    url: buildCmsUrl({
      path: 'slides-v-3-s',
      lang,
      limit: LIMIT_500,
      additionalParams: { populate: 'deep' },
    }),
    transformResponse: pipe(getResponseCamelization, getResponseCMS<Slide[]>),
  });

export const sliderCMS = isCMSV3 ? sliderCMSV3 : sliderCMSV4;

export interface SlideBenefit {
  text: string;
  textV2: string;
  crossSellText?: string;
  icon: CMSImageBase;
  iconV2: CMSImageBase;
}

export interface RegistrationSlide {
  benefits?: SlideBenefit[];
  order: number;
  title: string;
  backgroundDesktop: CMSImageBase;
  backgroundMobile: CMSImageBase;
  charactersDesktop: CMSImageBase;
  charactersMobile: CMSImageBase;
  titleColor?: string;
}

export const registrationSlidesCMSV3 = (lang: string) =>
  request<RegistrationSlide[]>({
    url: buildCmsUrl({ path: 'registration-slides', lang }),
  });

export const registrationSlidesCMSV4 = (lang: string) =>
  request<RegistrationSlide[]>({
    url: buildCmsUrl({
      path: 'registration-slides',
      lang,
      additionalParams: { populate: 'deep' },
    }),
    transformResponse: pipe(
      getResponseCamelization,
      getResponseCMS<RegistrationSlide[]>
    ),
  });

export const registrationSlidesCMS = isCMSV3
  ? registrationSlidesCMSV3
  : registrationSlidesCMSV4;
